const convertUTCToLocal = (utcDate) => {
  if (!utcDate) return null;
  const date = new Date(utcDate);
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
};

const convertLocalToUTC = (localDate) => {
  if (!localDate) return null;
  const date = new Date(localDate);
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
};

module.exports = { convertLocalToUTC, convertUTCToLocal };
